import { Tag } from "@dmm-com/rocket-web-ui-library";
import { memo } from "react";
import * as Styled from "./style";

type PurchaseStageWakuWakuBannerProps = {
  isWakuwari: boolean | undefined;
};

/** 舞台の購入モーダルで「イベント割対象作品」だった場合に表示するバナー */
export const PurchaseStageWakuWakuBanner = memo((props: PurchaseStageWakuWakuBannerProps) => {
  const { isWakuwari } = props;

  if (!isWakuwari) return null;

  return (
    <Styled.DivSaleContainer>
      <Tag tagText="セール" subText="イベント割対象" bgColor="RED900" subTextColor="RED900" />
    </Styled.DivSaleContainer>
  );
});

PurchaseStageWakuWakuBanner.displayName = "PurchaseStageWakuWakuBanner";
